import script from "./ViewTabBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTabBox.vue?vue&type=script&setup=true&lang=js"

import "./ViewTabBox.vue?vue&type=style&index=0&id=91fec33c&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91fec33c"]])

export default __exports__